import React, { useState, useEffect } from 'react';
import '../assets/styles/imageCarousel.css';

const images = [
];

const ImageCarousel = ({interval = 3000 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex === 0 ? images.length - 1 : prevIndex - 1));
  };
  
  useEffect(() => {
    const slideInterval = setInterval(nextSlide, interval);

    return () => {
      clearInterval(slideInterval);
    };
  }, [currentIndex, interval]);

  return (
    <div className="carousel-container">
      <div 
        className="carousel-slide" 
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {images.map((image, index) => (
          <img className='carousel-image' src={image} alt={`slide ${index}`} key={index} />
        ))}
      </div>
      <div className="arrow left" onClick={prevSlide}>
        &#10094;
      </div>
      <div className="arrow right" onClick={nextSlide}>
        &#10095;
      </div>
    </div>
  );
};

export default ImageCarousel;